import { ComplianceCategories } from '@ui/icons';
import { ComplianceCategory } from '@sonar-software/sonar-core';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Menu } from 'antd';
import { MenuInfo } from 'rc-menu/lib/interface';

import React, { useCallback } from 'react';
import { SearchGroup, SearchOptionGroup } from './DataDictionarySearch';

const complianceCategories = Object.entries(ComplianceCategory).filter(([ , id ]) => typeof id === 'number');

const menuItems: Array<SearchGroup> = [ {
	children: complianceCategories.map(([ , id ]) => ({
		group: SearchOptionGroup.Compliance,
		key: id,
		label: <ComplianceCategories categoryFlags={ Number(id) } />,
		value: id
	})),
	key: 'title',
	label: COPY_SPECIFIC.COMPLIANCE,
	type: 'group'
} ];

export interface QuickAccessComplianceCategorySelect {
	complianceCategory?: number,
	displayName?: string
}

export interface QuickAccessComplianceCategoriesProps {
	onSelect: (categoryId: QuickAccessComplianceCategorySelect) => void;
}

export const QuickAccessComplianceCategories: React.FC<QuickAccessComplianceCategoriesProps> = ({ onSelect }) => {
	const handleOnClick = useCallback((info: MenuInfo) => {
		const [ categoryName ] = complianceCategories.find(([ , id ]) => id === Number(info.key)) ?? [];

		onSelect({
			complianceCategory: Number(info.key),
			displayName: categoryName
		});
	}, [ onSelect ]);

	return (
		<Menu
			className='quick-access-menu'
			items={ menuItems }
			mode='inline'
			onClick={ handleOnClick } />
	);
};
